export default "__VITE_ASSET__Bf3jp4Ae__"